import { useEffect, useRef, useState } from "react";

/**
 * Custom hook to monitor the window width and check if it falls below a specified breakpoint.
 */
export function useWidth(breakpoint) {
    // State to track whether the window width is below the breakpoint.
    const [isLower, toggle] = useState(false);

    // State to track the current window width.
    const [width, setWidth] = useState(0);

    /**
     * Check the window width and update `isLower`:
     * - to `true` if window width is less than the breakpoint,
     * - to `false` if window width is more than the breakpoint.
     */
    const checkWidth = useRef(() => {});

    checkWidth.current = () => {
        setWidth(window.innerWidth);
        if (window.innerWidth < breakpoint) {
            toggle(true);
        } else {
            toggle(false);
        }
    };

    useEffect(() => {
        checkWidth.current();
        window.addEventListener("resize", checkWidth.current);
        return () => {
            window.removeEventListener("resize", checkWidth.current);
        };
    }, []);

    return { isLower, width };
}
